export const tenureCheck_en = {
  'title-section': {
    title: 'Tenure Verification',
    description: 'Please proceed with email verification to use the CIAM system',
  },
  form: {
    fields: {
      code: {
        label: 'Verification Code',
        placeholder: 'Enter code',
      },
      button: {
        continue: 'Continue',
        resend: 'Resend',
      },
    },
    'resend-success': 'Verification code has been sent.',
  },
  errors: {
    'invalid-parameter-value': 'Invalid verification code.',
    'send-default': 'An error occurred while sending the verification code.',
    'verify-default': 'An error occurred while verifying the verification code.',
  },
};
